/* Package JSON Import will be here */
import { v4 as uuidv4 } from 'uuid';
import { sumBy } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject } from "utilities/utils";
import { generateHashKeyApi } from "services/payment";
import { IHashGenerationParams } from "models/paymentModels";
import { getDmsHashGenerationApi } from "services/dms/dmsPayment";
import { IDmsHashGenerationRequest } from "models/dmsPaymentModels";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    PAYMENT_HASH_REQUEST: "paymentHash/paymentHashRequest",
    PAYMENT_HASH_SUCCESS: "paymentHash/paymentHashSuccess",
    PAYMENT_HASH_FAILURE: "paymentHash/paymentHashFailure",
    CLEAR_PAYMENT_HASH: "paymentHash/clearPaymentHash"
};

let initialState = {
    isLoading: false,
    data: {},
    error: null
};

export const paymentHash = (state = initialState, action) => {
    switch (action.type) {
        case types.PAYMENT_HASH_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.PAYMENT_HASH_SUCCESS:
            return {
                ...action.payload,
                isLoading: false
            };
        case types.PAYMENT_HASH_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.CLEAR_PAYMENT_HASH:
            return {
                ...state
            };
        default:
            return state;
    }
};

/* Payment hash key generation and initiate the process */
export const generatePaymentHashKey = (data: IHashGenerationParams) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.PAYMENT_HASH_REQUEST });
        try {
            let response = null;
            if (window.dmsServiceApiUrl !== "") {
                const localStoreObject = getState().localStore.user;
                /* Handling request params */
                const dmsRequestObj: IDmsHashGenerationRequest = {
                    RetailerCode: localStoreObject.retailercode,
                    DistributorCode: localStoreObject.distributorcode,
                    InvoiceList: data,
                    ReferenceNo: uuidv4(),
                    TotalAmount: sumBy(data, (o) => {
                        return o.Amount;
                    })
                };
                response = await getDmsHashGenerationApi(dmsRequestObj);

                /* Handling response params */
                response.data.Data = response.data.data;
            }
            else {
                response = await generateHashKeyApi(data);
            }

            dispatch({
                type: types.PAYMENT_HASH_SUCCESS,
                payload: {
                    data: response.data.Data
                }
            });

            /* Do not refresh page message info message */
            dispatch(showMsgFromJson(`common.alerts.info.doNotRefreshPage`, Constants.INFO));
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.PAYMENT_HASH_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Clear the hash details once the transaction got success or failure */
export const clearPaymentHash = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CLEAR_PAYMENT_HASH });
    }
};